'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _catalog = require('redux/actions/catalog');

var _constants = require('redux/constants');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Search: {
        displayName: 'Search'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Search/Search.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Search = _wrapComponent('Search')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT,
            page = parseInt(location.query.page, 10);

        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
            limit = _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;
        }
        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
            page = 1;
        }

        return dispatch((0, _catalog.getProducts)(params.input_state, --page, limit));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        products: state.catalog.products,
        count: state.catalog.count,
        activePage: state.catalog.activePage,
        limit: state.catalog.limit,
        searchName: state.catalog.searchName,
        lang: state.lang
    };
}, { push: _reactRouterRedux.push, setSearchClose: _catalog.setSearchClose }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(Search, _Component);

    function Search() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Search);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChangePage = function (page, limit) {
            _this.props.push('/search/' + _this.props.searchName + '?limit=' + limit + '&page=' + page);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Search, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('Search');
            var helmetTitle = this.props.lang['store.helmet.search_results'];

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
                _react3.default.createElement(View, (0, _extends3.default)({ handleChangePage: this.handleChangePage }, this.props))
            );
        }
    }]);
    return Search;
}(_react2.Component), _class2.propTypes = {
    products: _react2.PropTypes.array.isRequired,
    lang: _react2.PropTypes.object
}, _temp2)) || _class) || _class));

exports.default = Search;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Search/Search.jsx
// module id = 1845
// module chunks = 0